import React, { useEffect, Fragment, useRef } from "react";
import Breadcrumb from "../../../components/common/breadcrumb";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { GetCountryById, UpdateCountry } from "../../../api/masters/countryAPI";
import { useForm } from "react-hook-form";
import { showToast } from "../../../components/ToastifyNotification";
import { UncontrolledTooltip } from "reactstrap";
import useKeyboardSubmit from "../../../hooks/useKeyboardSubmit";
import useEnterNavigation from "../../../hooks/useEnterNavigation";

// Validation schema using Yup
const schema = yup.object().shape({
  name: yup.string().required("Name is required")
});

const EditCountry = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { id } = useParams();

  const { register, handleSubmit, setValue, formState: { errors } } = useForm({
    resolver: yupResolver(schema)
  });

  const fetchData = async () => {
    try {
      const response = await GetCountryById(id); // Make sure login function returns token

      if (response.success) {
        setValue("name", response.data.name); // Set default values
      } else {
        // setError(response.message);
        showToast("error", response.message);
      }
    } catch (error) {
      // setError(error); // Handle login errors
      showToast("error", error);
    }
  };

  // Fetch existing data
  useEffect(
    () => {
      const loadData = async () => {
        try {
          dispatch({ type: "LOADER_START" });

          await fetchData();
        } catch (error) {
          showToast("error", error);
        } finally {
          dispatch({ type: "LOADER_STOP" });
        }
      };

      loadData();
    },
    [id]
  );

  const onSubmit = async data => {
    try {
      dispatch({ type: "LOADER_START" });

      const response = await UpdateCountry(id, data);

      if (response.success) {
        showToast("success", response.message);
      } else {
        showToast("error", response.message);
      }
    } catch (error) {
      showToast("error", error);
    } finally {
      dispatch({ type: "LOADER_STOP" });
    }
  };

  const formRef = useRef(null);
  useKeyboardSubmit(handleSubmit, onSubmit);
  useEnterNavigation(formRef);

  return (
    <Fragment>
      <Breadcrumb parent="Country" title="Edit Country" />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header">
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <h5>Edit Country</h5>
                  <Link to={`/masters/country/list`}>
                    <button className="btn btn-primary" id="list">
                      List Country
                    </button>
                    <UncontrolledTooltip placement="top" target="list">
                      List Country
                    </UncontrolledTooltip>
                  </Link>
                </div>
              </div>
              <form
                ref={formRef}
                className="form theme-form"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="card-body">
                  <div className="row">
                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="name">Country Name*</label>
                        <input
                          className="form-control"
                          id="name"
                          type="text"
                          placeholder="Country Name"
                          {...register("name")}
                        />
                        {errors.name &&
                          <p className="text-danger">
                            {errors.name.message}
                          </p>}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer text-end">
                  <button className="btn btn-primary me-2" type="submit">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default EditCountry;
